const feedbackCard = {
  title: 'Feedback',
  by: 'By:',
  phone: 'Phone:',
  via: 'via',
  notes: 'Notes',
  submit: 'Add Feedback',
  source: {
    CrewLink: 'CrewLink',
    QR: 'QR',
    TripCard: 'Trip Card',
  },
};

export default feedbackCard;
